module.exports = "/assets/side-events-hero-bfw.jpg?gOiDUoR";